
<style>
  #main{
    display: inline-block;
    width: 100%;
    position: relative;
    /*overflow: scroll;*/
    height: 650px;
  }
  #big{
    overflow: hidden;
  }
  #big, div.jQBracket{
     /*overflow: scroll!important;*/
  }
  div.jQBracket{
    overflow: hidden;
    /*margin: 0 auto;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*/!* left: 50%; *!/*/
    /*/!* width: 100%; *!/*/
    /*transform: translate(0%,-50%);*/
    /*text-align: center;*/
  }
  div.jQBracket .team.win div.score {
    /*color: red!important;*/
    /*width: 0!important;*/
    /*opacity: 0;*/
    width: 35px!important;
  }
  div.jQBracket .team.lose div.score {
    /*color: #000!important;*/
    /*width: 0!important;*/
    /*opacity: 0;*/
    width: 35px!important;
  }
  .bubble{
    opacity: 0;
  }
  div.jQBracket .team div.label {
    /*width: 100%!important;*/
    /*text-align: center;*/
    /*text-align: center;*/
    line-height: 17px;
    width: 75%!important;
    overflow: hidden;
    white-space: nowrap;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
  }
  div.jQBracket .team.highlight{
    background-color:red!important;
  }
  .first{
    display: inline-block;
  }
  .first p{
    width: 100px;
    height: 22px;
  }
  div.jQBracket .team div.score{
    width: 35px!important;
  }
  .dy{
    width: 300px;
  }
  div.jQBracket .team.highlightLoser{
    color: #ffffff!important;
    background-color: #383838;
  }
  div.jQBracket .team.lose{
    color: #ffffff!important;
    background-color: #383838;
  }
  div.jQBracket .team.highlightWinner{
    background-color: #383838;
    color: #f54344;
  }
  div.jQBracket .connector.highlightWinner, div.jQBracket .connector div.connector.highlightWinner{
    border-color: #404040;
  }
  div.jQBracket .connector.highlightLoser, div.jQBracket .connector div.connector.highlightLoser{
    border-color: #404040;
  }
  div.jQBracket .team.win div.score{
    color: #f54344;
  }
  div.jQBracket .team.lose div.score{
    color: #ffffff;
  }
  div.jQBracket .team.highlight{
    background-color: #383838!important;
  }
</style>
<template>

<div id="main">
  <div id="big"></div>
</div>
</template>
<!--<link rel="stylesheet" href="./css/jquery.bracket.min.css"/>-->
<!--<script src="./js/jquery.js"></script>-->
<script src="./js/jquery.bracket.min.js"></script>
<script>
  export default {
    props: ["matchData"],
    components: {
    },
    data(){
      return {

      }
    },
    mounted(){
      let _this=this;
//      var yin=_this.matchData
//    console.log(_this.matchData)
        $(function() {
          var demos = ['big']
          $.each(demos, function(i, d){
            var demo = $('div#'+d)
            $('<div class="demo"></div>').appendTo(demo)
            var pre = $('<pre name="code" class="js"></pre>').appendTo(demo)
            var script = demo.find('script')
            demo.find("h3").append($('<a href="#' + d + '">¶</a>'))
            pre.text(script.html())
          })
        })
//      for(var p in _this.matchData.match.list){
//        _this.matchData.match.list[p] = Object.values(_this.matchData.match.list[p]);
//      }
//        var arr=_this.matchData.match.list[0][0];
//        var list=[]
//        if(yin){
//          for(var i=0;i<yin.length;i++){
//            for(var j=0;j<yin[i].length;j++){
//              list.push(yin[i][j])
//            }
//          }
//          for(var s=0;s<list.length;s++){
//            for(var arri=0;arri<list[s].length;arri++){
//              for(var k=0;k<list[s][arri].length;k++){
//                list[s][arri][k]=parseInt(list[s][arri][k])
//              }
//            }
//          }
//        }else{
//          for(var i=0;i<arr.length;i++)
//            list.push(0)
//        }
        console.log(_this.matchData)
        var bigData =_this.matchData
    $(function(){
          $('div#big .demo').bracket({
            teamWidth: 0,
            scoreWidth: 150,
            matchMargin: 20,
            roundMargin: 100,
            skipGrandFinalComeback: true,
            centerConnectors: true,
            disableHighlight: false,
            skipConsolationRound: true,
            init: bigData})
        })
        var isdrag=false;
        var NowLeft,disX;
        var NowTop,disY;
        var oDiv2 = document.getElementById("big");
        oDiv2.addEventListener('touchstart',thismousedown);
        oDiv2.addEventListener('touchend',thismouseup);
        oDiv2.addEventListener('touchmove',thismousemove);
        function thismousedown(e){
          isdrag = true;
          NowLeft = parseInt(oDiv2.style.left+0);
          NowTop = parseInt(oDiv2.style.top+0);
          disX = e.touches[0].pageX;
          disY = e.touches[0].pageY;
          return false;
        }
        function thismousemove(e){
          oDiv2.style.left = NowLeft + e.touches[0].pageX - disX + 'px';
          oDiv2.style.top = NowTop + e.touches[0].pageY - disY + 'px';
        }
        function thismouseup(){
          isdrag = false;
        };

    /* Custom data objects passed as teams */
//    var customData = {
//      teams : [
//        [{name: "Team 1", flag: 'gicon2'}, {name: "Team 1", flag: 'gicon2'}],
//        [{name: "Team 3", flag: 'se'}, {name: "Team 4", flag: 'us'}]
//      ],
//      results : [[
//        [[0,10], [20,1]],
//        [[8,2]],
//      ]]
//    }
//    function edit_fn(container, data, doneCb) {
//      var input = $('<input type="text">')
//      input.val(data ? data.flag + ':' + data.name : '')
//      container.html(input)
//      input.focus()
//      input.blur(function() {
//        var inputValue = input.val()
//        if (inputValue.length === 0) {
//          doneCb(null); // Drop the team and replace with BYE
//        } else {
//          var flagAndName = inputValue.split(':') // Expects correct input
//          doneCb({flag: flagAndName[0], name: flagAndName[1]})
//        }
//      })
//    }

//    function render_fn(container, data, score, state) {
//      switch(state) {
//        case "empty-bye":
//          container.append("No team")
//          return;
//        case "empty-tbd":
//          container.append("Upcoming")
//          return;
//        case "entry-no-score":
//        case "entry-default-win":
//        case "entry-complete":
//          container.append('<img src="../../assets/img/'+data.flag+'.png" /> ').append(data.name)
//          return;
//      }
//    }

//      $(function() {
//        $('div#big .demo').bracket({
//            teamWidth: 0,
//            scoreWidth: 150,
//            matchMargin: 20,
//            roundMargin: 100,
//            init: customData,
//            skipGrandFinalComeback: true,
//            centerConnectors: true,
//            disableHighlight: false,
//            skipConsolationRound: true,
//          decorator: {
//            edit: edit_fn,
//            render: render_fn
//          }})
//      })
    },
    methods:{

    },

  }
</script>



// WEBPACK FOOTER //
// src/components/bracket/index.vue